import React from "react";

// Rendu sûr d'un texte contenant du **gras** — sans dangerouslySetInnerHTML.
export function RichText({ text, className }) {
  const parts = String(text ?? "").split(/(\*\*[^*]+\*\*)/g);
  return (
    <span className={className}>
      {parts.map((p, i) =>
        p.startsWith("**") && p.endsWith("**") ? (
          <strong key={`b-${i}`} className="font-semibold text-foreground">
            {p.slice(2, -2)}
          </strong>
        ) : (
          <React.Fragment key={`t-${i}`}>{p}</React.Fragment>
        )
      )}
    </span>
  );
}
